import React from "react";
import { Eye, Send, MessageCircle, FileSignature, Trophy } from "lucide-react";
import KpiCard from "@/components/dashboard/KpiCard";
import { STAGE_TONE } from "@/lib/stageColors";
import { useLang } from "@/i18n";

const STAGE_ICON = {
  "Repéré": Eye,
  "Contacté": Send,
  "En discussion": MessageCircle,
  "Mandat signé": FileSignature,
  "Placé": Trophy,
};

/**
 * Dashboard lifecycle stage card.
 * BIG NUMBER = CURRENT STOCK of unique athletes in the stage (canonical, same as Pipeline).
 * Secondary lines = activity during the selected period (entries + vs previous period).
 * Sparkline = daily transitions INTO the stage during the period (real history, never fabricated stock).
 */
export default function StageKpiCard({ stage, data, rangeKey, rangeLabel, onClick, testid }) {
  const { t, tf } = useLang();
  const n = data?.period_count;
  const hasHistory = n !== null && n !== undefined;
  const prev = data?.prev_period_count;
  const delta = hasHistory && prev !== null && prev !== undefined ? n - prev : null;
  return (
    <KpiCard
      compact
      label={t(`status.${stage}`)}
      value={data?.total ?? 0}
      subLines={[
        hasHistory ? `+${n} · ${rangeLabel}` : tf("Historique en construction"),
        delta !== null ? `${delta >= 0 ? "+" : ""}${delta} ${tf("vs période précédente")}` : null,
      ]}
      icon={STAGE_ICON[stage] || Eye}
      tone={STAGE_TONE[stage] || "neutral"}
      spark={data?.spark}
      metric={`stage-${stage}`}
      rangeKey={rangeKey}
      tooltip={`${tf("Grand nombre = athlètes actuellement")} « ${t(`status.${stage}`)} » (${tf("identique au Pipeline, indépendant de la période")}). ${tf("Lignes secondaires et courbe = entrées dans l'étape sur la période sélectionnée.")}`}
      onClick={onClick}
      testid={testid}
    />
  );
}
